import { Container, Hidden } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import ProductWizardState from '../../model/ProductWizardState';
import { ProductWizardTitle } from '../ProductWizard/ProductWizardTitle/ProductWizardTitle';
import Screen from '../ProductWizard/Screen';
import IkeOrIkzeDesktop from './IkeOrIkzeDesktop';
import IkeOrIkzeMobile from './IkeOrIkzeMobile';
import {
  formatCurrencyWithoutTrailingZerosAndCode,
  formatCurrencyWithoutCode,
  formatCurrencyWholeNumber,
} from 'ui-components';

import useStyles from './IkeOrIkze.style';

export interface IkeOrIkzeLimits {
  year: number;
  ikeLimit: string;
  ikzeLimit: string;
  ikzeTaxLimit: string;
  ikzeEntrepreneurLimit?: string;
  ikzeEntrepreneurTaxLimit?: string;
}

const IkeOrIkze: React.FC = () => {

  const c = useStyles({});

  const limits = useSelector((state: ProductWizardState) => state.apiState.currentLimits);
  const maxIncomeTaxPercent = 0.32;

  const ikeOrIkzeLimits: IkeOrIkzeLimits = {
    year: limits.year,
    ikeLimit: formatCurrencyWithoutTrailingZerosAndCode(limits.currentLimits.IKE.limit),
    ikzeLimit: formatCurrencyWithoutCode(limits.currentLimits.IKZE.limit),
    ikzeTaxLimit: formatCurrencyWholeNumber(Math.round(limits.currentLimits.IKZE.limit * maxIncomeTaxPercent)),
    ikzeEntrepreneurLimit: limits.currentLimits.IKZE.entrepreneurLimit
                         ? formatCurrencyWithoutCode(limits.currentLimits.IKZE.entrepreneurLimit)
                         : undefined,
    ikzeEntrepreneurTaxLimit: limits.currentLimits.IKZE.entrepreneurLimit
                            ? formatCurrencyWholeNumber(Math.round(limits.currentLimits.IKZE.entrepreneurLimit * maxIncomeTaxPercent))
                            : undefined,
  };

  return (
    <Container maxWidth="xl">
      <ProductWizardTitle titleKey={Screen.IKE_OR_IKZE.code}/>
      <Container fixed className={c.container}>
        <Hidden smDown>
          <IkeOrIkzeDesktop limits={ikeOrIkzeLimits}/>
        </Hidden>
        <Hidden mdUp>
          <IkeOrIkzeMobile limits={ikeOrIkzeLimits}/>
        </Hidden>
      </Container>
    </Container>
  );
};

export default IkeOrIkze;
